import { NavLink, useNavigate } from 'react-router-dom';
import { clearCredentials, getAdminEmail } from '../api/admin-client';
import { useRole } from '../auth/role-context';
import ThemeToggle from './ThemeToggle';

const ROLE_BADGE_CLASS: Record<string, string> = {
  super_admin: 'badge-red',
  admin:       'badge-blue',
  moderator:   'badge-amber',
};

function roleBadgeClass(role: string): string {
  return ROLE_BADGE_CLASS[role] ?? 'badge-gray';
}

function displayName(email: string): string {
  if (!email) return '';
  // Use the part before @ as a friendly display name
  return email.split('@')[0] ?? email;
}

export default function Header() {
  const navigate = useNavigate();
  const email = getAdminEmail();
  const { role } = useRole();

  function handleLogout() {
    clearCredentials();
    navigate('/login', { replace: true });
  }

  return (
    <header className="header">
      <div className="header-brand">
        Lords <span>Admin</span>
      </div>

      <nav className="header-nav">
        <NavLink
          to="/accounts"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Account Lookup
        </NavLink>
        <NavLink
          to="/reports"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Report Queue
        </NavLink>
        <NavLink
          to="/shard-health"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Shard Health
        </NavLink>
        <NavLink
          to="/stripe-dead-letter"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Stripe DLQ
        </NavLink>
        <NavLink
          to="/audit-log"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Audit Log
        </NavLink>
        <NavLink
          to="/audit-log/live"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Live Audit
        </NavLink>
        <NavLink
          to="/abuse-signals"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Abuse Signals
        </NavLink>
        <NavLink
          to="/welcome-back"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Welcome-Back
        </NavLink>
      </nav>

      <div className="header-right">
        {/* "Admin: <displayName>" label + role badge */}
        {email && (
          <span className="header-identity" title={email}>
            Admin: <strong>{displayName(email)}</strong>
          </span>
        )}
        {role && role !== 'none' && (
          <span className={`badge ${roleBadgeClass(role)}`} style={{ fontSize: 11 }}>
            {role}
          </span>
        )}
        <ThemeToggle />
        <button className="btn btn-ghost btn-sm" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}
